import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/Home.vue'
import UserDetails from '../views/UserDetails.vue'
import LoginPage from '../views/Login.vue'
import Action from '../views/Action.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/user-details',
    name: 'UserDetails',
    component: UserDetails,
    meta: { requiresAuth: true }
  },
  {
    path: '/action',
    name: 'Action',
    component: Action,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 导航守卫确保只有已登录用户才能访问需要认证的页面
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.meta.requiresAuth && !token) {
    // 重定向到登录页而不是首页
    next({ 
      name: 'Login', 
      query: { 
        redirect: to.fullPath,
        error: '请先登录以访问该页面' 
      } 
    })
  } else {
    next()
  }
})

export default router 